import { render, staticRenderFns } from "./productTagsDialog.vue?vue&type=template&id=e129dd50&scoped=true"
import script from "./productTagsDialog.vue?vue&type=script&lang=js"
export * from "./productTagsDialog.vue?vue&type=script&lang=js"
import style0 from "./productTagsDialog.vue?vue&type=style&index=0&id=e129dd50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e129dd50",
  null
  
)

export default component.exports